import AlignElements from './AlignElements';

export default {
  __init__: [ 'alignElements' ],
  alignElements: [ 'type', AlignElements ]
};
